import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { SearchService } from '../../services/search.service';
import { Faq } from '../../../../../admin/src/app/models/faq';
import { Product } from '../../../../../admin/src/app/models/product';
import { Subscription } from 'rxjs';
import { AuthService } from '../../../../../admin/src/app/services/auth.service';
import { UserService } from '../../../../../admin/src/app/services/user.service';
import { FaqService } from '../../../../../admin/src/app/services/faq.service';
import { RoutingStateService } from '../../services/routing-state.service';
import { filter } from 'rxjs/operators';
import { LanguageService } from '../../services/language.service';
import { ZendeskService } from '../../services/zendesk.service';
import { ZendeskPageSearchResult, ZendeskSearchResult } from '../../models/zendesk-search-result';
import { MatomoTracker } from 'ngx-matomo';

export interface FaqsPage {

  page: number;

  faqs: Faq[];

}

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit, OnDestroy {

  products: Product[] = [];

  faqs: Faq[] = [];

  faqsPages: FaqsPage[] = [];

  zendeskResults: ZendeskSearchResult[] = [];

  zendeskError = false;

  query: string;

  currentPage: number = 0;

  sub: Subscription;

  sub2: Subscription;

  // isProductsVisible = false;

  // isFaqsVisible = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authSvc: AuthService,
    private faqSvc: FaqService,
    public searchSvc: SearchService,
    private userSvc: UserService,
    private routingState: RoutingStateService,
    private zendeskSvc: ZendeskService,
    public language: LanguageService,
    private matomoTracker: MatomoTracker
  ) { }

  ngOnInit() {
    this.matomoTracker.trackPageView('Search');

    this.sub = this.route.queryParamMap.subscribe(params => {
      this.query = params.get('q');
      if (!!this.query) {
        this.search();
      }
    });

    this.sub2 = this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe(({urlAfterRedirects}: NavigationEnd) => {
      let previousPage = this.routingState.getPreviousUrl().split('?').shift();
      let prevQuery = this.router.parseUrl(this.routingState.getPreviousUrl()).queryParamMap.get('q');
      let currentPage = urlAfterRedirects.split('?').shift();
      this.searchSvc.isSecondSearch = previousPage === currentPage && prevQuery !== this.query;
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
    this.sub2.unsubscribe();
  }

  loadProduct(product: Product) {
    this.router.navigate(['categories', product.category.id, product.id]);
  }

  isFirstPage() {
    return this.currentPage === 0;
  }

  isLastPage() {
    return this.currentPage === this.faqsPages.length - 1;
  }

  selectPage(page) {
    this.currentPage = page;
  }

  previousPage() {
    if (!this.isFirstPage()) {
      this.currentPage--;
    }
  }

  nextPage() {
    if (!this.isLastPage()) {
      this.currentPage++;
    }
  }

  search() {
    this.faqsPages = [];
    this.faqs = [];
    this.products = [];
    this.searchSvc.getAll(this.query, this.language.getLang()).subscribe(data => {
      let products = data.payload.products;
      let faqs = data.payload.faqs;

      this.products = Object.assign([], products);
      this.faqs = Object.assign([], faqs);

      let page: FaqsPage;
      faqs.forEach((faq, index) => {
        faq.contents.forEach((content) => {
          let urlRegex = /(http?:\/\/[^\s]+)/g;
          content.text = content.text.replace(urlRegex, function(url) {
            return '<a href="' + url + '" target="blank">' + url + '</a>';
          });
          urlRegex = /(https?:\/\/[^\s]+)/g;
          content.text = content.text.replace(urlRegex, function(url) {
            return '<a href="' + url + '" target="blank">' + url + '</a>';
          });
        });
        if (index % 3 === 0) {
          page = <FaqsPage>{ page: this.faqsPages.length, faqs: [] };
          this.faqsPages.push(page);
        }
        page.faqs.push(faq);
      });
    });
    this.zendeskSvc.search(this.query).subscribe(page => {
      this.zendeskError = false;
      if ((page as ZendeskPageSearchResult).results !== undefined) {
        this.zendeskResults = (page as ZendeskPageSearchResult).results;
      }
    }, _ => {
      this.zendeskError = true;
    });
  }

  updateSearch() {
    this.router.navigate([], { relativeTo: this.route, queryParams: { q: this.query }, queryParamsHandling: 'merge' });
  }

  isUserLoggedIn() {
    return !!this.authSvc.getCurrentToken();
  }

  hasLike(faq: Faq) {
    if (this.isUserLoggedIn()) {
      let user = this.userSvc.getUserInfo();
      return !!user && faq.likes.indexOf(user.id) !== -1;

    } else {
      return false;
    }
  }

  toggleLike(faq: Faq) {
    if (!this.hasLike(faq)) {
      this.faqSvc.addLike(faq.id).subscribe(data => {
        data.payload.contents.forEach((content) => {
          let urlRegex = /(http?:\/\/[^\s]+)/g;
          content.text = content.text.replace(urlRegex, function(url) {
            return '<a href="' + url + '" target="blank">' + url + '</a>';
          });
          urlRegex = /(https?:\/\/[^\s]+)/g;
          content.text = content.text.replace(urlRegex, function(url) {
            return '<a href="' + url + '" target="blank">' + url + '</a>';
          });
        });
        Object.assign(faq, data.payload);
      });
    } else {
      this.faqSvc.deleteLike(faq.id).subscribe(data => {
        data.payload.contents.forEach((content) => {
          let urlRegex = /(http?:\/\/[^\s]+)/g;
          content.text = content.text.replace(urlRegex, function(url) {
            return '<a href="' + url + '" target="blank">' + url + '</a>';
          });
          urlRegex = /(https?:\/\/[^\s]+)/g;
          content.text = content.text.replace(urlRegex, function(url) {
            return '<a href="' + url + '" target="blank">' + url + '</a>';
          });
        });
        Object.assign(faq, data.payload);
      });
    }
  }

  showHideZendeskResults() {
    this.searchSvc.isZendeskResultsVisible = !this.searchSvc.isZendeskResultsVisible;
  }

  showHideProducts() {
    this.searchSvc.isProductsVisible = !this.searchSvc.isProductsVisible;
  }

  showHideFaqs() {
    this.searchSvc.isFaqsVisible = !this.searchSvc.isFaqsVisible;
  }
}
